<script setup lang="ts">
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import { adminLogin } from '../api';

const router = useRouter();
const username = ref('admin1');
const password = ref('admin123456');
const loading = ref(false);

async function submit() {
  if (!username.value || !password.value) {
    ElMessage.warning('请输入用户名密码');
    return;
  }
  loading.value = true;
  try {
    const admin = await adminLogin(username.value, password.value);
    if (admin.role !== 'PLATFORM_ADMIN') {
      ElMessage.error('此后台仅供总后台管理员使用,审核员请前往审核员后台');
      return;
    }
    ElMessage.success('登录成功');
    router.push('/home');
  } catch (e) {
    const err = e as { message?: string; code?: string };
    ElMessage.error(err.message || err.code || '登录失败');
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <div class="login">
    <el-card class="card">
      <template #header>
        <div class="title">总后台 · 登录</div>
      </template>
      <el-form label-width="72px" @submit.prevent="submit">
        <el-form-item label="用户名">
          <el-input v-model="username" placeholder="admin1 (seed 默认)" autofocus />
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="password" type="password" show-password placeholder="admin123456" />
        </el-form-item>
        <el-button type="primary" :loading="loading" @click="submit" style="width: 100%">
          登录
        </el-button>
      </el-form>
      <div class="hint">
        开发期默认账号:admin1 / admin123456(PLATFORM_ADMIN)
      </div>
    </el-card>
  </div>
</template>

<style scoped>
.login { min-height: 100vh; display: flex; justify-content: center; align-items: center; background: #f5f5f7; }
.card { width: 440px; }
.title { font-size: 20px; font-weight: 600; }
.hint { margin-top: 16px; color: #86868b; font-size: 12px; }
</style>
